'use client'

import { createAnalyticsConsent } from '@repo/observability/analytics-consent'
import posthog from 'posthog-js/dist/module.full.no-external'

import { registerActiveExperiments } from './experiment-properties'
import { notifyAnalyticsIdentityChanged } from './identity'

// Persisted localStorage key — renaming it would silently re-default every
// existing user's analytics-consent choice.
const ANALYTICS_STORAGE_KEY = 'vvrm-analytics-opted-in'

export const { useAnalyticsConsent, isAnalyticsOptedOut, syncAnalyticsOptOutCookie } =
  createAnalyticsConsent({
    storageKey: ANALYTICS_STORAGE_KEY,
    posthog: {
      opt_in_capturing: () => {
        posthog.opt_in_capturing()
        // Nothing is written while opted out, so restore both halves of the
        // experiment state here. The property first, then the announcement that
        // makes the tracker re-capture `experiment_exposed`: a person created
        // during the opt-out has tagged events but no exposure row, and
        // PostHog's join drops it. Deduped, so every other opt-in is a no-op.
        registerActiveExperiments()
        notifyAnalyticsIdentityChanged()
      },
      opt_out_capturing: () => posthog.opt_out_capturing()
    }
  })
